import { getFileUrl } from '@weblite/file'

export const getUserImageUrl = user =>
  user ? (user.deletedAt ? null : getImageUrl(user.image)) : null

export const getImageUrl = image => image && getFileUrl(image)
